import { ExaminersList } from '../../../components/ExaminersStructure/ExaminersStructure.types';
import { AssessmentQuality } from '../../../models/assessment.types';
import { BlockadeMessage } from '../../../models/signalR.types';
import { AssessmentSessionProcessTypeId, Status } from '../../../services/exams/assessmentSession/assessments.types';
import { DashboardTile } from '../../Dashboard/Dashboard.types';

export const convertExamTaskGroupSolutionState = (state: string): string => {
  switch (state) {
    case 'Nowe':
      return Status.New.toString();
    case 'Otwarte':
      return Status.Open.toString();
    case 'Ocenione':
      return Status.Assessed.toString();
    case 'Zamknięte':
      return Status.Closed.toString();
    default:
      return Status.Closed.toString();
  }
};

export const convertExamTaskGroupSolutionStateFromEnumId = (state: string): string => {
  const enumId = Number(state);
  if (enumId > Object.keys(Status).length / 2) return '';

  const enumVal = enumId as Status;
  switch (enumVal) {
    case Status.New:
      return 'Nowe';
    case Status.Open:
      return 'Otwarte';
    case Status.Assessed:
      return 'Ocenione';
    case Status.Closed:
      return 'Zamknięte';
    default:
      return '';
  }
};

export const convertAssessmentQualityStateScoring = (state: string): string => {
  switch (state) {
    case 'Ocena poza zakresem tolerancji':
      return AssessmentQuality.Inaccurate.toString();
    case 'Wystąpiły rozbieżności w ocenie':
      return AssessmentQuality.WithinTolerance.toString();
    case 'Ocena dokładna':
      return AssessmentQuality.Accurate.toString();
    default:
      return '';
  }
};
export const convertAssessmentQualityStateForTraining = (state: string): string => {
  switch (state) {
    case 'Wystąpiły rozbieżności w ocenie':
      return AssessmentQuality.Inaccurate.toString();
    case 'Ocena dokładna':
      return AssessmentQuality.Accurate.toString();
    default:
      return '';
  }
};
export const isExaminerBlockadeStatusForChange = (
  assessmentSession: DashboardTile | null,
  examiner: ExaminersList,
  message: BlockadeMessage,
  loggedUserId?: string,
) => {
  if (
    loggedUserId &&
    examiner.examiner?.id !== loggedUserId &&
    examiner.examiner?.examinerPermission?.id === message.examinerPermissionId
  ) {
    return false;
  }
  return (
    message.assessmentSessionId === assessmentSession?.assessmentSessionId &&
    message.examinerPermissionId === examiner.examiner?.examinerPermission?.id
  );
};

export const Statuses = [
  {
    id: Status.New.toString(),
    label: 'Nowe',
  },
  {
    id: Status.Open.toString(),
    label: 'Otwarte',
  },
  {
    id: Status.Assessed.toString(),
    label: 'Ocenione',
  },
  {
    id: Status.Closed.toString(),
    label: 'Zamknięte',
  },
];

export const getAssessmentQualityLabel = (status: string, processTypeId?: AssessmentSessionProcessTypeId) => {
  switch (status) {
    case AssessmentQuality.Accurate.toString():
      return 'Ocena dokładna';
    case AssessmentQuality.WithinTolerance.toString():
      return processTypeId === AssessmentSessionProcessTypeId.Qualification
        ? 'Ocena w zakresie tolerancji'
        : 'Wystąpiły rozbieżności w ocenie';
    case AssessmentQuality.Inaccurate.toString():
      return processTypeId === AssessmentSessionProcessTypeId.Training
        ? 'Wystąpiły rozbieżności w ocenie'
        : 'Ocena poza zakresem tolerancji';
    default:
      return '';
  }
};

export const Alerts = [
  {
    id: '1',
    label: 'Komentarz do kryterium',
  },
  {
    id: '2',
    label: 'Komentarz na stronie',
  },
  {
    id: '3',
    label: 'Komentarz poza stroną',
  },
  {
    id: '4',
    label: 'Nierozstrzygnięty szczególny przypadek',
  },
  {
    id: '5',
    label: 'Zamknięty szczególny przypadek',
  },
  {
    id: '6',
    label: 'Zadanie kontrolne',
  },
  {
    id: '7',
    label: 'Dostosowane zasady oceniania',
  },
  {
    id: '8',
    label: 'Ocena zmieniona',
  },
  {
    id: '9',
    label: 'Wiadomość',
  },
];

export const Verifier = [
  {
    id: '5',
    label: 'Weryfikator przypisany',
  },
  {
    id: '4',
    label: 'Prace możliwe do przypisania',
  },
  {
    id: '0',
    label: 'Praca niezweryfikowana',
  },
  {
    id: '1',
    label: 'Praca zweryfikowana - brak zmian w ocenie',
  },
  {
    id: '2',
    label: 'Praca zweryfikowana - czeka na zatwierdzenie PZE',
  },
  {
    id: '3',
    label: 'Praca zweryfikowana - zatwierdzona PZE',
  },
]
